import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum ProductOrderFields {
    ITEMS = 'items',
    DIRECTION = 'direction',
    DUE_DATE = 'dueDate',
    REF_PROFILE_TYPE = 'refProfileType',
    REF_PROFILE = 'refProfile',
    REF_NAME = 'refName',
    REF_EMAIL = 'refEmail',
    REF_ADDRESS = 'refAddress',
    INVOICE = 'invoice',
    FULFILLMENT_STATE = 'fulfillmentState',
    FULFILLED_AT = 'fulfilledAt',
    FULFILLED_BY = 'fulfilledBy',
    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
}

export namespace ProductOrderFields {
    type Data = { text: string; readonly?: true; updateOnly?: true; };

    export const Record: Record<ProductOrderFields, Data> = {
        [ProductOrderFields.ITEMS]: {
            text: 'Artikel',
        },
        [ProductOrderFields.DIRECTION]: {
            text: 'Richtung des Wahrenverkehrs',
        },
        [ProductOrderFields.DUE_DATE]: {
            text: 'Fälligkeitsdatum',
        },
        [ProductOrderFields.REF_PROFILE_TYPE]: {
            text: 'Profilart',
        },
        [ProductOrderFields.REF_PROFILE]: {
            text: 'Profil',
        },
        [ProductOrderFields.REF_NAME]: {
            text: 'Name des Absenders / Empfängers',
        },
        [ProductOrderFields.REF_EMAIL]: {
            text: 'E-Mail-Adresse des Absenders / Empfängers',
        },
        [ProductOrderFields.REF_ADDRESS]: {
            text: 'Anschrift des Absenders / Empfängers',
        },
        [ProductOrderFields.INVOICE]: {
            text: 'Rechnung',
        },
        [ProductOrderFields.FULFILLMENT_STATE]: {
            text: 'Ausführungsstatus',
            readonly: true,
        },
        [ProductOrderFields.FULFILLED_AT]: {
            readonly: true,
            text: 'Erfüllt am',
        },
        [ProductOrderFields.FULFILLED_BY]: {
            readonly: true,
            text: 'Erfüllt von',
        },
        [ProductOrderFields.CREATED_AT]: {
            text: 'Erstellt am',
        },
        [ProductOrderFields.UPDATED_AT]: {
            text: 'Aktualisiert am',
        },
    }

    export const Items = mapRecordToItems(Record);
}
